import React from "react";
import dashboardclasses from "../../Pages/dashboard.module.css";
import ScaleLoader from "react-spinners/ScaleLoader";
import { css } from "@emotion/react";
function Loader() {
    const override = css`
 display: block;
 margin: 0 auto;
 border-color: red;
`;
    return (
        <div>
            {" "}
            <div className={dashboardclasses["loader"]}>
                <ScaleLoader
                    color={"black"}
                    loading={true}
                    css={override}
                    size={150}
                />
            </div>
        </div>
    );
}

export default Loader;
